import { getPackageName } from "../utils";
const namespace = `io.github.t83714/${getPackageName()}/SagaRegistry`;
export default namespace;
